/**
 * LYKIT ENTERTAINMENT PVT. LTD. — site copy.
 *
 * Copy marked EXACT below is supplied by the client and must not be rewritten.
 * Copy marked DERIVED is assembled only from client-supplied brand language and
 * is editable placeholder text (no invented claims, clients, numbers or awards).
 */

export const COMPANY = {
  legalName: "LYKIT ENTERTAINMENT PVT. LTD.",
  shortName: "LYKIT",
  wordmarkSub: "ENTERTAINMENT PVT. LTD.",
  // EXACT
  tagline: "Creating Experiences. Producing Stories. Connecting Audiences. Driving Impact.",
  secondaryTagline: "Where Entertainment Meets Purpose.",
  addressFull: "3rd Main, R.T.Nagar, K H M Block, Ganganagar, Bengaluru, Karnataka 560032",
  addressLines: ["3rd Main, R.T.Nagar, K H M Block,", "Ganganagar, Bengaluru,", "Karnataka 560032"],
  email: "Contact@lykitmedia.com",
  city: "Bengaluru, India",
  mapsEmbed:
    "https://www.google.com/maps?q=3rd+Main+Road,+KHM+Block,+Ganganagar,+R.T.+Nagar,+Bengaluru,+Karnataka+560032&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=3rd+Main+Road%2C+KHM+Block%2C+Ganganagar%2C+R.T.+Nagar%2C+Bengaluru%2C+Karnataka+560032",
  social: [
    { label: "Instagram", href: "https://www.instagram.com/" },
    { label: "Facebook", href: "https://www.facebook.com/" },
    { label: "YouTube", href: "https://www.youtube.com/" },
    { label: "LinkedIn", href: "https://www.linkedin.com/" },
  ],
};

export const SERVICES_MENU = [
  { label: "Event Management", to: "/services/events", desc: "Corporate, public and entertainment experiences." },
  { label: "Advertising & Brand Solutions", to: "/services/advertising", desc: "Campaigns, activations and sponsorships." },
  { label: "Social Impact & Crowdfunding", to: "/services/social-impact", desc: "Causes, storytelling and participation." },
  { label: "OTT & Digital Entertainment", to: "/services/ott-digital", desc: "Digital-first content and programming." },
  { label: "Post-Production Studio", to: "/services/post-production", desc: "Editing, colour, sound, VFX and delivery." },
];

export const NAV_LINKS = [
  { label: "HOME", to: "/" },
  { label: "ABOUT US", to: "/about" },
  { label: "SERVICES", to: "/services/events", children: SERVICES_MENU },
  { label: "OUR WORK", to: "/work" },
  { label: "COLLABORATION", to: "/partners" },
  { label: "CAREERS", to: "/careers" },
  { label: "CONTACT", to: "/contact" },
];

export const HERO = {
  eyebrow: COMPANY.legalName,
  // EXACT — four lines, do not rewrite
  headline: ["Creating Experiences.", "Producing Stories.", "Connecting Audiences.", "Driving Impact."],
  // EXACT
  supporting:
    "LYKIT Entertainment Pvt. Ltd. is a multi-dimensional entertainment and media company bringing together events, advertising, digital entertainment, OTT, post-production and social-impact initiatives under one creative ecosystem.",
  primaryCta: { label: "EXPLORE OUR SERVICES", to: "/services/events" },
  secondaryCta: { label: "LET'S COLLABORATE", to: "/contact" },
};

export const WHO_WE_ARE = {
  eyebrow: "WHO WE ARE",
  // EXACT
  heading: ["MORE THAN ENTERTAINMENT.", "A PLATFORM FOR POSSIBILITIES."],
  // EXACT — three sentences, kept verbatim
  body: [
    "At LYKIT, we believe that entertainment is not limited to what happens on a screen or stage.",
    "It is about ideas, people, stories, brands, technology and experiences coming together.",
    "We create and manage experiences, develop content, deliver creative solutions, build digital entertainment opportunities and enable collective participation in meaningful social causes.",
  ],
  cta: { label: "DISCOVER LYKIT", to: "/about" },
};

export const VERTICALS = [
  {
    id: "events",
    num: "01",
    title: "EVENTS",
    menuTitle: "Event Management",
    slug: "events",
    to: "/services/events",
    tagline: "Experiences That People Remember.",
    // EXACT
    description:
      "From concept to execution, we create memorable experiences for brands, organisations and audiences.",
    services: [
      "Corporate Events",
      "Public Events",
      "Entertainment Shows",
      "Conferences",
      "Felicitations",
      "Brand Activations",
    ],
    cta: "EXPLORE EVENTS",
  },

  {
    id: "advertising",
    num: "02",
    title: "ADVERTISING",
    menuTitle: "Advertising & Brand Solutions",
    slug: "advertising",
    to: "/services/advertising",
    tagline: "Turning Attention Into Connection.",
    // EXACT
    description:
      "Creative brand solutions designed to build visibility, engagement and lasting audience connections.",
    services: ["Campaigns", "Digital Advertising", "Brand Activations", "Sponsorships", "Experiential Marketing"],
    cta: "EXPLORE ADVERTISING",
  },

  {
    id: "social-impact",
    num: "03",
    title: "SOCIAL IMPACT",
    menuTitle: "Social Impact & Crowdfunding",
    slug: "social-impact",
    to: "/services/social-impact",
    tagline: "Your Cause. Our Platform. Collective Impact.",
    // EXACT
    description:
      "Using storytelling, digital platforms and collective participation to support meaningful social causes.",
    services: [
      "Healthcare",
      "Education",
      "Elder Care",
      "Child Welfare",
      "Rehabilitation",
      "Livelihood",
      "Community Development",
    ],
    cta: "EXPLORE SOCIAL IMPACT",
  },

  {
    id: "ott-digital",
    num: "04",
    title: "OTT & DIGITAL ENTERTAINMENT",
    menuTitle: "OTT & Digital Entertainment",
    slug: "ott-digital",
    to: "/services/ott-digital",
    tagline: "Stories Made for the Digital World.",
    // EXACT
    description:
      "Developing engaging digital-first content and creating opportunities for stories, creators and audiences.",
    services: [
      "Original Content",
      "Web Series",
      "Documentaries",
      "Interviews",
      "Regional Content",
      "Digital Programming",
    ],
    cta: "EXPLORE DIGITAL ENTERTAINMENT",
  },

  {
    id: "post-production",
    num: "05",
    title: "POST-PRODUCTION STUDIO",
    menuTitle: "Post-Production Studio",
    slug: "post-production",
    to: "/services/post-production",
    tagline: "Your Story. Our Studio. A Powerful Final Cut.",
    // EXACT
    description: "A professional creative studio transforming raw footage into polished, compelling content.",
    services: [
      "Editing",
      "Colour Grading",
      "Sound",
      "Motion Graphics",
      "VFX",
      "Animation",
      "Dubbing",
      "Subtitling",
    ],
    cta: "EXPLORE STUDIO",
  },
];

// EXACT
export const APPROACH = [
  { num: "01", title: "IDEATE", text: "Understanding the vision, objective and audience." },
  { num: "02", title: "CREATE", text: "Turning ideas into experiences, campaigns, content and platforms." },
  { num: "03", title: "CONNECT", text: "Bringing together brands, creators, audiences and communities." },
  { num: "04", title: "DELIVER", text: "Executing with professionalism, creativity and attention to detail." },
  { num: "05", title: "IMPACT", text: "Creating measurable value and meaningful experiences." },
];

// EXACT
export const WHY_LYKIT = [
  {
    num: "01",
    title: "Integrated Capabilities",
    text: "Multiple creative and entertainment services within one ecosystem.",
  },
  {
    num: "02",
    title: "End-to-End Execution",
    text: "From strategy and concept to production, promotion and delivery.",
  },
  {
    num: "03",
    title: "Creative Excellence",
    text: "Ideas designed to capture attention and create lasting impressions.",
  },
  {
    num: "04",
    title: "Technology Driven",
    text: "Modern digital and production capabilities supporting every project.",
  },
  {
    num: "05",
    title: "Collaborative Network",
    text: "Connecting brands, creators, artists, organisations and communities.",
  },
  {
    num: "06",
    title: "Purpose With Business",
    text: "Creating commercial value while opening avenues for meaningful social impact.",
  },
];

export const FOUNDERS_SECTION = {
  header: "THE VISIONARIES BEHIND LYKIT ENTERTAINMENT.",
  subheading: "Pavan Kumar M S & Ravishekhar B K",
  intro:
    "LYKit Entertainment Pvt. Ltd. is founded on the shared vision of two creative minds from Bengaluru, united by a passion for storytelling, entertainment and meaningful experiences.",
  closing: [
    "Together, they have come forward to build LYKit Entertainment Pvt. Ltd. — a creative and entertainment company driven by imagination, collaboration and purpose.",
    "From entertainment and event experiences to creative productions and impactful initiatives, LYKit aspires to bring together talent, innovation and meaningful storytelling under one platform.",
  ],
  signature: "Two creative minds. One shared vision. A new journey in entertainment.",
};

export const FOUNDERS = [
  {
    num: "01",
    name: "Ravishekhar B K",
    role: "Founder & Director",
    image: "/brand/portrait-ravishekhar.jpg",
    bio: "An actor, model and social worker, he brings his experience in performance, visual presentation, community work and the entertainment world. His passion for creativity, audience engagement and social impact adds a dynamic dimension to the company's vision.",
  },
  {
    num: "02",
    name: "Pavan Kumar M S",
    role: "Founder & Director",
    image: "/brand/portrait-pavan.jpg",
    bio: "A film director, writer and event management professional with a background in journalism. He brings together creative vision, compelling narratives, event management expertise and a deep understanding of the entertainment industry. His experience in storytelling, media and events inspires LYKit's creative direction and artistic ambition.",
  },
];

/**
 * LYKIT ENTERTAINMENT x IBMCT — the single, focused collaboration that replaces
 * the old placeholder partner grid.
 */
export const COLLABORATION = {
  title: "LYKIT ENTERTAINMENT X IBMCT",
  shortTitle: "LYKIT Entertainment × IBMCT",
  url: "https://ibmct.org",
  urlLabel: "IBMCT.org",
  linkLabel: "VISIT IBMCT.ORG",
  eyebrow: "Who We Work With",
  shortNote:
    "LYKIT Entertainment is collaborating with IBMCT for crowdfunding — bringing verified social causes to wider audiences.",
  lead: "LYKIT Entertainment is collaborating with IBMCT for crowdfunding.",
  body: [
    "Rather than a long list of logos, we work closely with a small number of organisations we believe in. IBMCT is one of them.",
    "Together we bring verified social causes to wider audiences — pairing LYKIT's storytelling, production and distribution capability with IBMCT's on-ground trust and reach, so collective participation turns attention into real contribution.",
  ],
  points: [
    { title: "Crowdfunding", text: "Verified causes taken to audiences through honest, human storytelling." },
    { title: "Storytelling", text: "Films, campaigns and content that give a cause its voice." },
    { title: "Collective Impact", text: "Outcomes reported back to everyone who took part." },
  ],
};

// EXACT category names, DERIVED one-line descriptors
export const PARTNER_CATEGORIES = [
  { title: "Brands", text: "Brands building visibility, engagement and audience connection." },
  { title: "Corporates", text: "Organisations creating events, content and internal experiences." },
  { title: "Creators & Artists", text: "Creators, performers and artists developing new work." },
  { title: "Production Partners", text: "Crews, studios and technical partners across formats." },
  { title: "Media Partners", text: "Platforms and publishers extending reach and distribution." },
  { title: "Social Organisations", text: "Organisations working on verified social causes." },
];

export const PARTNERSHIP_TYPES = [
  "Brand Partnership",
  "Corporate Partnership",
  "Creator / Artist Collaboration",
  "Production Partnership",
  "Media Partnership",
  "Social Organisation",
  "Other",
];

// EXACT focus areas, DERIVED short descriptors
export const FOCUS_AREAS = [
  { title: "Healthcare", text: "Supporting access to treatment, care and medical support." },
  { title: "Education", text: "Enabling learning access for students and young people." },
  { title: "Elder Care", text: "Standing with senior citizens who need care and company." },
  { title: "Child Welfare", text: "Protecting, supporting and creating opportunity for children." },
  { title: "Rehabilitation", text: "Helping people rebuild after illness, loss or displacement." },
  { title: "Livelihood", text: "Backing skills, work and self-reliance in communities." },
  { title: "Community Development", text: "Strengthening the shared spaces communities depend on." },
];

// EXACT step labels, DERIVED short descriptors
export const HOW_IT_WORKS = [
  { num: "1", title: "SUBMIT", text: "A cause is submitted with its purpose, requirement and context." },
  { num: "2", title: "VERIFY", text: "Details and documentation are reviewed before anything goes live." },
  { num: "3", title: "TELL", text: "The story is shaped into honest, human content people can trust." },
  { num: "4", title: "CONNECT", text: "The cause is taken to audiences, brands and communities." },
  { num: "5", title: "SUPPORT", text: "Collective participation turns attention into contribution." },
  { num: "6", title: "IMPACT", text: "Outcomes are reported back to everyone who took part." },
];

export const SOCIAL_IMPACT = {
  // EXACT
  heading: "ENTERTAINMENT WITH A PURPOSE.",
  tagline: "Your Cause. Our Platform. Collective Impact.",
  // DERIVED from supplied vertical description
  body: "Using storytelling, digital platforms and collective participation to support meaningful social causes.",
  crowdfundingHeading: ["YOUR CAUSE.", "OUR PLATFORM.", "COLLECTIVE IMPACT."],
  homeCta: "SUPPORT A CAUSE",
  campaignCta: "START A CAMPAIGN",
};

export const CLOSING_CTA = {
  // EXACT
  heading: ["HAVE AN IDEA?", "LET'S BRING IT TO LIFE."],
  text: "Whether you are a brand, organisation, creator, artist, production partner or social initiative, LYKIT is ready to collaborate.",
  cta: "START A CONVERSATION",
};

/* ------------------------------------------------------------------ ABOUT */
export const ABOUT = {
  // EXACT
  hero: ["WE CREATE.", "WE CONNECT.", "WE ENABLE."],
  storyHeading: "BUILT AROUND AN IDEA.",
  // DERIVED strictly from supplied hero + who-we-are copy
  story: [
    "LYKIT was built around a simple idea — that entertainment is not limited to what happens on a screen or stage.",
    "It is about ideas, people, stories, brands, technology and experiences coming together.",
    "Around that idea we brought together events, advertising, digital entertainment, OTT, post-production and social-impact initiatives under one creative ecosystem.",
  ],
  vision:
    "To build an integrated entertainment ecosystem where experiences, stories, brands, technology and communities come together — creating commercial value while opening avenues for meaningful social impact.",
  mission: [
    "Create and manage experiences for brands, organisations and audiences.",
    "Develop content and build digital entertainment opportunities.",
    "Deliver creative solutions with professionalism and attention to detail.",
    "Connect brands, creators, artists, organisations and communities.",
    "Enable collective participation in meaningful social causes.",
  ],
  // EXACT value names, DERIVED one-line descriptors
  values: [
    { num: "01", title: "CREATIVITY", text: "Ideas designed to capture attention and create lasting impressions." },
    { num: "02", title: "INTEGRITY", text: "Honest work, clear commitments and responsible execution." },
    { num: "03", title: "EXCELLENCE", text: "Craft and detail carried through every stage of delivery." },
    { num: "04", title: "INNOVATION", text: "Modern digital and production capabilities supporting every project." },
    { num: "05", title: "COLLABORATION", text: "Meaningful work created when the right people come together." },
    { num: "06", title: "RESPONSIBILITY", text: "Business built alongside avenues for meaningful social impact." },
  ],
  note: "Story, Vision and Mission copy is assembled from LYKIT's supplied brand language and can be replaced with final approved text.",
};

/* ------------------------------------------------------------------ SERVICE PAGES */
export const SERVICE_PAGES = {
  events: {
    eyebrow: "SERVICE 01",
    title: "EVENT MANAGEMENT",
    tagline: "Experiences That People Remember.",
    intro: [
      "From concept to execution, we create memorable experiences for brands, organisations and audiences.",
      "Every event is planned as a complete production — idea, design, logistics, technology, talent and show flow handled by one team.",
    ],
    capabilitiesLabel: "WHAT WE DELIVER",
    capabilities: [
      { title: "Corporate Events", text: "Annual days, launches, summits, offsites and internal celebrations." },
      { title: "Public Events", text: "Large-format public programmes and ticketed properties." },
      { title: "Entertainment Shows", text: "Live shows with artists, hosts, music and stage production." },
      { title: "Conferences", text: "Sessions, speaker management, stage design and delegate experience." },
      { title: "Felicitations", text: "Award nights and recognition ceremonies with dignified staging." },
      { title: "Brand Activations", text: "On-ground brand experiences designed for direct interaction." },
    ],
    accent: "light",
  },
  advertising: {
    eyebrow: "SERVICE 02",
    title: "ADVERTISING & BRAND SOLUTIONS",
    tagline: "Turning Attention Into Connection.",
    intro: [
      "Creative brand solutions designed to build visibility, engagement and lasting audience connections.",
      "Campaign thinking, content production and distribution are handled together so an idea stays intact from brief to audience.",
    ],
    capabilitiesLabel: "WHAT WE DELIVER",
    capabilities: [
      { title: "Campaigns", text: "Campaign platforms built around a single, clear idea." },
      { title: "Digital Advertising", text: "Performance and brand campaigns across digital surfaces." },
      { title: "Brand Activations", text: "Experiences that put audiences inside the brand." },
      { title: "Sponsorships", text: "Property, event and content sponsorship structures." },
      { title: "Experiential Marketing", text: "Ideas that people can walk into, touch and remember." },
    ],
    accent: "light",
  },
  "ott-digital": {
    eyebrow: "SERVICE 04",
    title: "OTT & DIGITAL ENTERTAINMENT",
    tagline: "Stories Made for the Digital World.",
    intro: [
      "Developing engaging digital-first content and creating opportunities for stories, creators and audiences.",
      "Formats are developed for how people actually watch today — episodic, regional, mobile-first and built to travel.",
    ],
    capabilitiesLabel: "WHAT WE DEVELOP",
    capabilities: [
      { title: "Original Content", text: "Ideas developed in-house from concept to delivery." },
      { title: "Web Series", text: "Episodic formats written for digital viewing patterns." },
      { title: "Documentaries", text: "Long-form non-fiction on people, place and process." },
      { title: "Interviews", text: "Conversation formats with creators, artists and leaders." },
      { title: "Regional Content", text: "Stories made in the language of their audience." },
      { title: "Digital Programming", text: "Slate planning, scheduling and platform strategy." },
    ],
    accent: "dark",
  },
  "post-production": {
    eyebrow: "SERVICE 05",
    title: "POST-PRODUCTION STUDIO",
    tagline: "Your Story. Our Studio. A Powerful Final Cut.",
    intro: [
      "A professional creative studio transforming raw footage into polished, compelling content.",
      "Picture, colour, sound and graphics are finished under one roof, with delivery specifications handled for every platform.",
    ],
    capabilitiesLabel: "STUDIO CAPABILITIES",
    capabilities: [
      { title: "Editing", text: "Story-first offline and online editing." },
      { title: "Colour Grading", text: "Look development and shot-to-shot consistency." },
      { title: "Sound", text: "Dialogue clean-up, design and final mix." },
      { title: "Motion Graphics", text: "Titles, lower-thirds and brand-led design systems." },
      { title: "VFX", text: "Clean-up, compositing and screen replacements." },
      { title: "Animation", text: "2D and explainer animation for brand and content work." },
      { title: "Dubbing", text: "Multi-language voice recording and sync." },
      { title: "Subtitling", text: "Accurate subtitles and captions for every platform." },
    ],
    accent: "light",
  },
  "social-impact": {
    eyebrow: "SERVICE 03",
    title: "SOCIAL IMPACT & CROWDFUNDING",
    tagline: "Your Cause. Our Platform. Collective Impact.",
    intro: [
      "Using storytelling, digital platforms and collective participation to support meaningful social causes.",
      "Causes are verified before they are told, and outcomes are reported back to everyone who took part.",
    ],
    capabilitiesLabel: "FOCUS AREAS",
    capabilities: FOCUS_AREAS,
    accent: "light",
  },
};

/* ------------------------------------------------------------------ CAREERS */
export const CAREERS = {
  // EXACT
  heading: ["BUILD THE FUTURE OF", "ENTERTAINMENT WITH US."],
  intro:
    "LYKIT brings together events, advertising, digital entertainment, OTT, post-production and social-impact initiatives under one creative ecosystem — and every one of them needs people who care about craft.",
  traitsLabel: "PEOPLE WE LOOK FOR",
  // EXACT traits, DERIVED one-liners
  traits: [
    { title: "Creative", text: "You bring ideas, not just execution." },
    { title: "Curious", text: "You ask what else is possible." },
    { title: "Responsible", text: "You own the outcome, not only the task." },
    { title: "Collaborative", text: "You make the people around you better." },
    { title: "Ambitious", text: "You want to build something that lasts." },
  ],
  // EXACT
  opportunities: [
    "Event Management",
    "Production",
    "Video Editing",
    "Post-Production",
    "Advertising",
    "Digital Marketing",
    "Content Creation",
    "OTT & Digital Entertainment",
    "Business Development",
    "Social Impact",
    "Operations",
    "Technology",
  ],
  ctaPrimary: "VIEW OPENINGS",
  ctaSecondary: "SEND YOUR PROFILE",
};

/* ------------------------------------------------------------------ CONTACT */
export const CONTACT = {
  // EXACT
  heading: "LET'S START A CONVERSATION.",
  text: [
    "Have an idea, project, campaign, event or collaboration in mind?",
    "Tell us what you're building.",
    "Our team will get in touch with you.",
  ],
  serviceOptions: [
    "Event Management",
    "Advertising",
    "Social Impact",
    "OTT & Digital Entertainment",
    "Post-Production",
    "Partnership",
    "Other",
  ],
  submitLabel: "SEND ENQUIRY",
  mapHeading: "FIND US",
  directionsLabel: "GET DIRECTIONS",
};

export const WORK_FILTERS = ["ALL", "EVENTS", "ADVERTISING", "SOCIAL IMPACT", "DIGITAL", "PRODUCTION"];

export const WORK_PAGE = {
  heading: ["OUR WORK", "IDEAS. EXPERIENCES. STORIES."],
  note: "Project entries below are structured placeholders. Real project details, credits and imagery are added by the LYKIT team.",
};

/* ------------------------------------------------------------------ FOOTER */
export const FOOTER_QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services/events" },
  { label: "Our Work", to: "/work" },
  { label: "Social Impact", to: "/social-impact" },
  { label: "Collaboration", to: "/partners" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_LEGAL = [
  { label: "Privacy Policy", to: "/legal/privacy" },
  { label: "Terms & Conditions", to: "/legal/terms" },
  { label: "Disclaimer", to: "/legal/disclaimer" },
  { label: "Cookie Policy", to: "/legal/cookies" },
  { label: "Refund & Cancellation Policy", to: "/legal/refund" },
];

/* ------------------------------------------------------------------ LEGAL */
const legalIntro = `This page applies to the website of ${COMPANY.legalName}, ${COMPANY.addressFull}. For any question about this document, write to ${COMPANY.email}.`;

export const LEGAL_PAGES = {
  privacy: {
    title: "Privacy Policy",
    eyebrow: "LEGAL",
    updated: "Last updated: January 2026",
    sections: [
      { heading: "Overview", body: [legalIntro] },
      {
        heading: "Information We Collect",
        body: [
          "We collect the information you choose to share with us through our enquiry, careers, partnership and campaign forms — typically your name, organisation, email address, phone number and the details of your requirement.",
          "We also collect basic technical information such as browser type and pages visited, which helps us keep the website working well.",
        ],
      },
      {
        heading: "How We Use Information",
        body: [
          "Your information is used to respond to your enquiry, evaluate collaborations, process applications, verify causes and improve our services.",
          "We do not sell your personal information.",
        ],
      },
      {
        heading: "Data Retention & Security",
        body: [
          "Submissions are stored in our systems for as long as needed to respond to you and to maintain business records, and are protected with reasonable technical and organisational measures.",
        ],
      },
      {
        heading: "Your Rights",
        body: [
          `You can ask us to access, correct or delete the information you have shared by writing to ${COMPANY.email}.`,
        ],
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    eyebrow: "LEGAL",
    updated: "Last updated: January 2026",
    sections: [
      { heading: "Acceptance", body: [legalIntro, "By using this website you agree to these terms."] },
      {
        heading: "Use of the Website",
        body: [
          "The website is provided for information about our services and for initiating contact with us. You agree not to misuse the website, attempt unauthorised access or disrupt its normal operation.",
        ],
      },
      {
        heading: "Intellectual Property",
        body: [
          "The LYKIT name, logo, wordmark and website content belong to LYKIT Entertainment Pvt. Ltd. unless stated otherwise. Third-party photography used for illustration remains the property of its respective owners.",
        ],
      },
      {
        heading: "Engagements",
        body: [
          "Projects, events, productions and campaigns are governed by a separate written agreement, proposal or work order signed between LYKIT and the client or partner. Nothing on this website constitutes an offer or contract.",
        ],
      },
      {
        heading: "Governing Law",
        body: ["These terms are governed by the laws of India, with jurisdiction in Bengaluru, Karnataka."],
      },
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    eyebrow: "LEGAL",
    updated: "Last updated: January 2026",
    sections: [
      { heading: "General", body: [legalIntro] },
      {
        heading: "Website Content",
        body: [
          "Information on this website is provided for general reference. While we keep it as accurate as possible, we make no warranty that it is complete or current at all times.",
        ],
      },
      {
        heading: "Project Listings",
        body: [
          "Project entries shown in Our Work may include structured placeholder records while final case-study content is being prepared. These entries are clearly marked and do not represent a claim of engagement with any brand or organisation.",
        ],
      },
      {
        heading: "External Links",
        body: [
          "We are not responsible for the content, policies or availability of external websites linked from this site.",
        ],
      },
    ],
  },
  cookies: {
    title: "Cookie Policy",
    eyebrow: "LEGAL",
    updated: "Last updated: January 2026",
    sections: [
      { heading: "About Cookies", body: [legalIntro] },
      {
        heading: "How We Use Them",
        body: [
          "We use a small number of essential cookies and similar browser storage to keep the website working, remember your preferences and understand how pages are used in aggregate.",
        ],
      },
      {
        heading: "Managing Cookies",
        body: [
          "You can clear or block cookies from your browser settings at any time. Some parts of the website may not work as expected if essential cookies are blocked.",
        ],
      },
    ],
  },
  refund: {
    title: "Refund & Cancellation Policy",
    eyebrow: "LEGAL",
    updated: "Last updated: January 2026",
    sections: [
      { heading: "Scope", body: [legalIntro] },
      {
        heading: "Services & Projects",
        body: [
          "Events, productions, campaigns and studio work are commissioned under a written agreement. Cancellation windows, retained amounts and refund eligibility are defined in that agreement, because committed costs such as venues, crew, talent and vendors are incurred in advance.",
        ],
      },
      {
        heading: "Cancellation Requests",
        body: [
          `Cancellation requests must be sent in writing to ${COMPANY.email} with the project reference. We acknowledge every request and confirm the applicable position under the signed agreement.`,
        ],
      },
      {
        heading: "Social Impact Contributions",
        body: [
          "Contributions made towards a verified cause are directed to that cause and are generally non-refundable. If a campaign is cancelled before disbursement, contributors are informed and handled as per the campaign terms.",
        ],
      },
    ],
  },
};

/* ------------------------------------------------------------------ SEO */
export const SEO = {
  home: {
    title: "LYKIT Entertainment Pvt. Ltd. | Events, Advertising, OTT & Digital Entertainment",
    description:
      "LYKIT Entertainment Pvt. Ltd. is a multi-dimensional entertainment and media company bringing together events, advertising, digital entertainment, OTT, post-production and social-impact initiatives.",
  },
  about: {
    title: "About LYKIT Entertainment | Media, Entertainment & Creative Solutions",
    description:
      "We create, we connect, we enable. Learn about LYKIT Entertainment's story, vision, mission and values.",
  },
  events: {
    title: "Event Management Company in Bengaluru | LYKIT Entertainment",
    description:
      "Corporate events, public events, entertainment shows, conferences, felicitations and brand activations by LYKIT Entertainment, Bengaluru.",
  },
  advertising: {
    title: "Advertising & Brand Solutions | LYKIT Entertainment",
    description:
      "Campaigns, digital advertising, brand activations, sponsorships and experiential marketing that turn attention into connection.",
  },
  "ott-digital": {
    title: "OTT & Digital Entertainment | LYKIT Entertainment",
    description:
      "Original content, web series, documentaries, interviews, regional content and digital programming made for the digital world.",
  },
  "post-production": {
    title: "Post-Production Studio in Bengaluru | LYKIT Entertainment",
    description:
      "Editing, colour grading, sound, motion graphics, VFX, animation, dubbing and subtitling from LYKIT's post-production studio.",
  },
  "social-impact": {
    title: "Social Impact & Crowdfunding | LYKIT Entertainment",
    description:
      "Your cause. Our platform. Collective impact. Storytelling and collective participation for healthcare, education, elder care, child welfare and more.",
  },
  work: {
    title: "Our Work | LYKIT Entertainment",
    description: "Ideas. Experiences. Stories. Selected work across events, advertising, digital, production and social impact.",
  },
  partners: {
    title: "LYKIT Entertainment X IBMCT | Collaboration",
    description:
      "LYKIT Entertainment is collaborating with IBMCT for crowdfunding — bringing verified social causes to wider audiences through storytelling and collective participation.",
  },
  careers: {
    title: "Careers | LYKIT Entertainment",
    description: "Build the future of entertainment with us. Opportunities across events, production, post-production, advertising and digital.",
  },
  contact: {
    title: "LYKIT Entertainment Pvt. Ltd. | Bengaluru",
    description:
      "Let's start a conversation. LYKIT Entertainment Pvt. Ltd., 3rd Main, R.T.Nagar, K H M Block, Ganganagar, Bengaluru, Karnataka 560032.",
  },
};

export default COMPANY;
